import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ENTITLEMENTS_CUSTOMER_QUERY, {
	type entitlementsCustomerQuery,
} from '@atlassian/jira-relay/src/__generated__/entitlementsCustomerQuery.graphql';

export const entitlementsCustomerQueryResource = createRelayResource<entitlementsCustomerQuery>({
	type: 'ENTITLEMENTS_CUSTOMER_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: ENTITLEMENTS_CUSTOMER_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
